export default {
  options: {
    start: 0,
    end: -1,
    min_track_length: 50,
    phase: 0,
  },
};
